"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmPlugin = void 0;
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const core_ui_1 = require("@sierralabs/core-ui");
const ConfirmConfigurator = props => {
    var _a, _b;
    const { condition, onChange } = props;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_1.Box, { mt: 2 },
            react_1.default.createElement(core_1.TextField, { fullWidth: true, variant: 'outlined', label: 'Dialog Title', value: ((_a = condition.params) === null || _a === void 0 ? void 0 : _a.title) || '', onChange: event => {
                    if (condition.params) {
                        condition.params.title = event.target.value;
                        onChange === null || onChange === void 0 ? void 0 : onChange(Object.assign({}, condition));
                    }
                } })),
        react_1.default.createElement(core_1.Box, { mt: 2 },
            react_1.default.createElement(core_1.TextField, { fullWidth: true, variant: 'outlined', label: 'Confirm Message', value: ((_b = condition.params) === null || _b === void 0 ? void 0 : _b.message) || '', onChange: event => {
                    if (condition.params) {
                        condition.params.message = event.target.value;
                        onChange === null || onChange === void 0 ? void 0 : onChange(Object.assign({}, condition));
                    }
                } }))));
};
const ConfirmDisplay = () => {
    return react_1.default.createElement(react_1.default.Fragment, null, "Confirm Dialog");
};
exports.ConfirmPlugin = {
    type: 'confirm',
    label: 'Confirm Dialog',
    configurator: ConfirmConfigurator,
    display: ConfirmDisplay,
    validate: () => true,
    guard: (state, params, render) => {
        if (state.isSimulation)
            return true;
        if (!render)
            return false;
        return new Promise(resolve => {
            render(react_1.default.createElement(core_ui_1.ConfirmDialog, { open: true, title: params.title || '', message: params.message || '', onCancel: () => {
                    render(undefined);
                    resolve(false);
                }, onConfirm: () => {
                    render(undefined);
                    resolve(true);
                } }));
        });
    }
};
//# sourceMappingURL=ConfirmPlugin.js.map